import React from "react";
import { useSearchParams } from "react-router-dom";
import { GalacticBackground } from "./GalacticBackground";
import { FootballBackground } from "./FootballBackground";
import "./Background.css";

export const Background = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const color1 = `#${searchParams.get("color1") || "0078D4"}`;
  const color2 = `#${searchParams.get("color2") || "001530"}`;

  if (type === "galactic") {
    return <GalacticBackground color1={color1} color2={color2} />;
  }

  if (type === "football" || type === "footbal") {
    return <FootballBackground color1={color1} color2={color2} />;
  }

  // Default: simple CSS gradient
  return (
    <div
      className="bg-container"
      style={{
        background: `linear-gradient(135deg, ${color1}, ${color2})`,
      }}
    />
  );
};

export default Background;
